import * as classNames from 'classnames';
import * as React from 'react';
import { CardBody, CardSubtitle, CardTitle } from 'reactstrap';
import { pure } from 'recompose';
import LoadingSpinner from '../LoadingSpinner';
import './ActivityCardBody.scss';
import { ActivityProps } from './types';
import { getDurationPartsForDisplay } from './utils';

const ActivityCardBody = (props: ActivityProps & { className?: string }) => {
    const { loading, activity, error, className } = props;

    if (loading) {
        return (
            <CardBody>
                <LoadingSpinner />
            </CardBody>
        );
    }

    if (error || !activity || !activity.stats) {
        return <CardBody />;
    }

    const { name, type, location, timeSinceActivityInWords, stats } = activity;
    const { distance, elapsedTime, averagePace, averageSpeed } = stats;

    return (
        <CardBody className={className}>
            <CardSubtitle>{name}</CardSubtitle>
            <CardTitle className="mt-1">{location}</CardTitle>
            <CardSubtitle className="mt-3">
                <span className="activity-statistic small">
                    {timeSinceActivityInWords}
                </span>
            </CardSubtitle>
            <CardSubtitle className="mt-2 mb-0">
                <span className="activity-statistic">
                    {(distance.value || 0).toFixed(2)}
                </span>
                {' ' + distance.units}
            </CardSubtitle>
            <CardSubtitle className="mt-2 mb-0">
                <DurationText durationInSeconds={elapsedTime.value * 60} />
            </CardSubtitle>
            <CardSubtitle className="mt-2">
                {type === 'Run' ? (
                    <>
                        <DurationText
                            durationInSeconds={(averagePace.value || 0) * 60}
                        />
                        {' ' + averagePace.units}
                    </>
                ) : (
                    <>
                        <span className="activity-statistic">
                            {(averageSpeed.value || 0).toFixed(2)}
                        </span>
                        {' ' + averageSpeed.units}
                    </>
                )}
            </CardSubtitle>
        </CardBody>
    );
};

const DurationText: React.StatelessComponent<{
    durationInSeconds?: number;
    className?: string;
}> = ({
    className,
    durationInSeconds
}: {
    className?: string;
    durationInSeconds?: number;
}) => {
    const timeParts = getDurationPartsForDisplay(durationInSeconds || 0, false);

    return (
        <span className={classNames('activity-statistic', className || '')}>
            {timeParts.hours ? (
                <>
                    {timeParts.hours}
                    <span className="units">{'h '}</span>
                </>
            ) : null}
            {timeParts.minutes}
            <span className="units">{'m '}</span>
            {timeParts.seconds}
            <span className="units">s</span>
        </span>
    );
};

export default pure(ActivityCardBody);



// WEBPACK FOOTER //
// ./src/client/components/Strava/ActivityCardBody.tsx